import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LoginPage } from './components/LoginPage';
import { Dashboard } from './components/Dashboard';
import { UploadFiles } from './components/UploadFiles';
import { MassBalance } from './components/MassBalance';
import { InboundSummary } from './components/InboundSummary';
import { OutboundSummary } from './components/OutboundSummary';
import { ReportsLibrary } from './components/ReportsLibrary';
import { CustomQuery } from './components/CustomQuery';
import { ProtectedRoute } from './components/ProtectedRoute';
import { CodeMappings } from './components/CodeMappings';
import { RegionalTonnage } from './components/RegionalTonnage';
import { FacilityFlow } from './components/FacilityFlow';
import { FacilityScorecard } from './components/FacilityScorecard';
import { CapacityLimits } from './components/CapacityLimits';
import { MyAccount } from './components/MyAccount';
import { ManageUsers } from './components/ManageUsers';
import { ForgotPassword } from './components/ForgotPassword';
import { AIAssistant } from './components/AIAssistant';
import { CompanyProfile } from './components/CompanyProfile';
import { IdleTimeout } from './components/IdleTimeout';

function App() {
  return (
    <Router>
      <AuthProvider>
        <IdleTimeout />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/upload" element={<ProtectedRoute><UploadFiles /></ProtectedRoute>} />
          <Route path="/reports/mass-balance" element={<ProtectedRoute><MassBalance /></ProtectedRoute>} />
          <Route path="/reports/inbound-summary" element={<ProtectedRoute><InboundSummary /></ProtectedRoute>} />
          <Route path="/reports/outbound-summary" element={<ProtectedRoute><OutboundSummary /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><ReportsLibrary /></ProtectedRoute>} />
          <Route path="/custom-query" element={<ProtectedRoute><CustomQuery /></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
					<Route path="/settings/code-mappings" element={<ProtectedRoute><CodeMappings /></ProtectedRoute>} />
					<Route path="/reports/regional-tonnage" element={<ProtectedRoute><RegionalTonnage /></ProtectedRoute>} />
					<Route path="/reports/facility-flow" element={<ProtectedRoute><FacilityFlow /></ProtectedRoute>} />
					<Route path="/reports/facility-scorecard" element={<ProtectedRoute><FacilityScorecard /></ProtectedRoute>} />
					<Route path="/reports/capacity-limits" element={<ProtectedRoute><CapacityLimits /></ProtectedRoute>} />
					<Route path="/my-account" element={<ProtectedRoute><MyAccount /></ProtectedRoute>} />
					<Route path="/admin/users" element={<ProtectedRoute><ManageUsers /></ProtectedRoute>} />
					<Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/ai-assistant" element={<ProtectedRoute><AIAssistant /></ProtectedRoute>} />
					<Route path="/company-profile" element={<ProtectedRoute><CompanyProfile /></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
